import React from "react";
import { setOptionEdit } from "../../reducer/tourEditReducer";
import { Paths } from "../../router/Paths";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import RoleBasedComponent from "../../components/RoleBasedComponent";

export default function ManageMeetingPointSection({ optionData }: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(setOptionEdit(optionData._id));
    // Ensure meetingPoint is set for the edit page
    const optionDataWithMeetingPoint = {
      ...optionData,
      meetingPoint:
        optionData.meetingPoint ||
        (optionData.meetingAddress
          ? { address: optionData.meetingAddress }
          : undefined),
    };
    navigate(Paths.tourManagementPackageOptionsMeeting, {
      state: { optionData: optionDataWithMeetingPoint },
    });
  };

  const isMeetingPoint = optionData?.meetingSetting === "meeting_point";
  const isSpecificAreas = optionData?.meetingSetting === "specific_areas";

  return (
    <section className="bg-white p-2 sm:p-6">
      <div className="flex justify-between items-center">
        <p className="text-xl font-bold">Meeting Point or Pickup</p>
        <RoleBasedComponent allowedRoles={["supplier"]}>
          <button
            onClick={handleEdit}
            className="text-sm text-primary underline font-bold"
          >
            Edit
          </button>
        </RoleBasedComponent>
      </div>
      {/* content  */}
      <div className="flex flex-col sm:items-end gap-6">
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full text-sm">
            <div className="space-y-2">
              <p className="font-bold">Meeting Setting</p>
              <p className="text-secondary capitalize">
                {isMeetingPoint
                  ? "Meeting Point"
                  : isSpecificAreas
                  ? "Specific Areas"
                  : "N/A"}
              </p>
            </div>
          </div>
          {/* Meeting Point fields */}
          {isMeetingPoint && (
            <div className="w-full">
              <div className="space-y-2">
                <p className="text-sm font-bold">Meeting Address</p>
                <p className="text-secondary capitalize">
                  {optionData?.meetingAddress ?? "N/A"}
                </p>
              </div>
            </div>
          )}
          {/* Specific Areas fields */}
          {isSpecificAreas && (
            <div className="w-full">
              <div className="space-y-2">
                <p className="text-sm font-bold">Pickup Service</p>
                <p className="text-secondary capitalize">
                  {optionData?.pickupService ?? "N/A"}
                </p>
              </div>
            </div>
          )}
        </div>
        {/* Meeting Point fields */}
        {isMeetingPoint && (
          <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
            <div className="w-full">
              <div className="space-y-2">
                <p className="text-sm font-bold">Meeting Description</p>
                <p className="text-secondary capitalize">
                  {optionData?.meetingPointDescription ?? "N/A"}
                </p>
              </div>
            </div>
            <div className="w-full">
              <div className="space-y-2">
                <p className="text-sm font-bold">
                  When do customers need to arrive?
                </p>
                <p className="text-secondary capitalize">
                  {optionData?.arrivalTime ?? "N/A"}
                </p>
              </div>
            </div>
          </div>
        )}
        {/* Specific Areas fields */}
        {isSpecificAreas && (
          <>
            <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
              <div className="w-full">
                <div className="space-y-2">
                  <p className="text-sm font-bold">Pickup Description</p>
                  <p className="text-secondary capitalize">
                    {optionData?.pickupDescription ?? "N/A"}
                  </p>
                </div>
              </div>
              <div className="w-full">
                <div className="space-y-2">
                  <p className="text-sm font-bold">Pickup Areas</p>
                  <p className="text-secondary capitalize">
                    {optionData?.pickupAreas?.length
                      ? optionData.pickupAreas.join(", ")
                      : "N/A"}
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
              <div className="w-full">
                <div className="space-y-2">
                  <p className="text-sm font-bold">Pickup Addresses</p>
                  <p className="text-secondary capitalize">
                    {optionData?.pickupAdresses?.length
                      ? optionData.pickupAdresses.join(", ")
                      : "N/A"}
                  </p>
                </div>
              </div>
              <div className="w-full">
                <div className="space-y-2">
                  <p className="text-sm font-bold">Pickup Notice</p>
                  <p className="text-secondary capitalize">
                    {optionData?.pickupNotice ?? "N/A"}
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
              <div className="w-full">
                <div className="space-y-2">
                  <p className="text-sm font-bold">Pickup Time</p>
                  <p className="text-secondary capitalize">
                    {optionData?.pickupTime ?? "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
        {/* Drop Off (for both types) */}
        <div className="w-full max-w-[836px] flex flex-col sm:flex-row gap-6">
          <div className="w-full">
            <div className="space-y-2">
              <p className="text-sm font-bold">Drop Off</p>
              <p className="text-secondary capitalize">
                {optionData?.dropOff ?? "N/A"}
              </p>
            </div>
          </div>
          {/* Drop Off Address and Transportation Type for Specific Areas */}
          {isSpecificAreas && (
            <>
              <div className="w-full">
                <div className="space-y-2">
                  <p className="text-sm font-bold">Drop Off Address</p>
                  <p className="text-secondary capitalize">
                    {optionData?.dropOffAddress ?? "N/A"}
                  </p>
                </div>
              </div>
              <div className="w-full">
                <div className="space-y-2">
                  <p className="text-sm font-bold">
                    Drop Off Transportation Type
                  </p>
                  <p className="text-secondary capitalize">
                    {optionData?.dropoffTransportationType ?? "N/A"}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
